// removed by extract-text-webpack-plugin
module.exports = {"short-input-answers":"ShortTextField__short-input-answers___2z2bc"};